import { ItiBaseDto } from '@/iti-core-vue';

export class ItiScheduledTask extends ItiBaseDto {
    public Name!: string;
    public Identifier!: string;
    public Cron!: string;
    public IsActive!: boolean;
    public Timeout!: number;
    public IsRunning!: boolean;
}
